export function course_curriculum() {
  
  $(document).ready(function() {
     
    $('.product-course-curriculum__full-course-button').click(function(e) {
      e.preventDefault();
      var text = $(this).text();
      $(this).text(text == $(this).data('open-lessons-text') ? $(this).data('close-lessons-text') : $(this).data('open-lessons-text'));
      $(this).closest('.product-course-curriculum__container').find('.js-curriculum-second-container').toggleClass('product-course-curriculum__lessons--hide');
    });
  
  });
  
}


// WEBPACK FOOTER //
// ./assets/js/blocks/course_curriculum.js